export interface Call {
    id?: number;
    recordingSid: string;
    callSid: string;
    externalNumber: string;
    outbound: boolean;

    /** UTC datetime when the call was initiated. Parse with moment.utc() for proper timezone conversion. */
    initiated: Date;

    agent: string;
    fileName: string;
    duration: number;
    patientId: number;
    disposition: string;

    // Patient information (from JOIN)
    patientFirstName?: string;
    patientLastName?: string;

    // Audit-related properties
    auditQuestionSetId?: number;
    auditCompletedBy?: string;

    /** UTC datetime when the call audit was completed. Parse with moment.utc() for proper timezone conversion. */
    auditCompletedAt?: Date;
}

export class Call {
    constructor(obj?: Call) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
